const results = [
  { icon: 'ri-radar-line', text: 'Понятная картина компетенций сотрудников' },
  { icon: 'ri-alert-line', text: 'Выявленные зоны развития' },
  { icon: 'ri-rocket-line', text: 'Понимание потенциала команды' },
  { icon: 'ri-scales-3-line', text: 'Более обоснованные решения о развитии' },
  { icon: 'ri-vip-crown-line', text: 'Сформированный кадровый резерв' },
  { icon: 'ri-file-list-3-line', text: 'Индивидуальные планы развития' },
  { icon: 'ri-links-line', text: 'Связь оценки и обучения' },
  { icon: 'ri-wallet-3-line', text: 'Более адресное использование бюджета на обучение' },
  { icon: 'ri-checkbox-circle-line', text: 'Единые критерии оценки сотрудников' },
  { icon: 'ri-focus-3-line', text: 'Понимание, какие компетенции развивать в первую очередь' },
];

export default function CompanyResults() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Результат оценки и развития сотрудников проявляется в конкретных управленческих возможностях, а не в абстрактных показателях.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${r.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}